import { navigateTo, parseInt10 } from '#imports';
import { Injectable } from '@kaokei/use-vue-service';
import qs from 'query-string';
import { CROSS_ZONE_WHITELIST } from '@core/utils/constant';
import { getZoneBase } from '@core/utils/runtime-config';

@Injectable()
export class RouterService {
  public route: any;
  public router: any;

  public getRoute() {
    return this.router.currentRoute;
  }
  public getRouteQuery() {
    return this.getRoute().query || {};
  }
  public getRouteQueryGroupId() {
    const q = this.getRouteQuery();
    const gid = q.gid || q.groupId;
    if (gid) {
      return parseInt10(gid);
    }
  }
  public setRouter(router: any) {
    this.router = router;
  }

  public replace(...args: any) {
    this.router.replace(...args);
  }

  public replaceUrl(url: string) {
    top?.location.replace(url);
  }

  public push(...args: any) {
    this.router.push(...args);
  }

  public updateZone(zone: string) {
    const pathname = location.pathname;
    const pagename = pathname.split('/').slice(2).join('/');
    const isCrossZone = CROSS_ZONE_WHITELIST.includes(pagename);
    if (isCrossZone) {
      location.href = `/${zone}/${pagename}`;
    } else {
      if (pagename.indexOf('admin') === 0) {
        location.href = `/${zone}/admin`;
      } else {
        location.href = `/${zone}`;
      }
    }
  }

  public updateQuery(newQuery: any, forceReload = false) {
    const query = { ...this.getRouteQuery(), ...newQuery };
    if (forceReload) {
      const search = qs.stringify(query);
      location.href = `${location.pathname}?${search}`;
    } else {
      this.router.replace({ query });
    }
  }

  public removeQuery(removeKeys: string[], forceReload = false) {
    const query = { ...this.getRouteQuery() };
    for (const k of removeKeys) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete query[k];
    }
    if (forceReload) {
      const search = qs.stringify(query);
      location.href = `${location.pathname}?${search}`;
    } else {
      this.router.replace({ query });
    }
  }

  public addQuery(newQuery: any, forceReload = false) {
    const query = { ...this.getRouteQuery(), ...newQuery };
    if (forceReload) {
      const search = qs.stringify(query);
      location.href = `${location.pathname}?${search}`;
    } else {
      this.router.replace({ query });
    }
  }

  public topReplace(url: string) {
    const parsed = qs.parseUrl(url);
    const r = parsed?.query?.redirect;
    if (r) {
      top?.location.replace(decodeURIComponent(r as string));
    } else {
      top?.location.replace(url);
    }
  }

  public reload() {
    // @ts-expect-error 有的浏览器不支持reload参数
    top?.location.reload(true);
  }

  /**
   * 登录成功后重定向到新页面
   * 优先从URL中获取redirect参数
   * 如果没有则刷新当前页面
   * todo: 注意到这里的redirect目前是使用的router.replace也就是没有刷新页面
   * 这是因为在登录成功后，如果刷新页面可能会导致绑定手机号的弹窗和个人资料的弹窗弹出干扰到用户
   * 比如邀请用户加入小组，用户先登录，登录成功后会replace到中间页面，加入小组成功后刷新页面到小组首页，此时才会显示绑定手机号和完善个人资料的弹窗
   */
  public reloadAfterLogin() {
    const q = this.getRouteQuery();
    const redirect = q.redirect;
    if (redirect) {
      this.topReplace(redirect);
    } else {
      this.reload();
    }
  }

  public reloadHome() {
    top?.location.replace('/');
  }

  /**
   * 从创建题目页面返回到题目列表页面
   * 可能是题库的题目列表，也可能是小组的题目列表
   * 如果都没有，则返回浏览器的上一个页面
   */
  public backFromCreateProblem() {
    const q = this.getRouteQuery();
    if (q.wid) {
      navigateTo({ name: 'admin_warehouse_problem', query: { wid: q.wid } });
    } else if (q.gid) {
      navigateTo({ name: 'admin_group_problem_list', query: { gid: q.gid } });
    } else {
      this.router.back();
    }
  }

  /**
   * 去小组主页
   * @param id 小组ID
   * @param zone 小组所属域
   */
  public goToGroupHome(id: number, zone: string, existed: boolean) {
    let url = `${getZoneBase(zone)}/oj/group/problem/?gid=${id}`;
    if (!existed) {
      // 第一次加入小组，需要弹出toast提示
      url += '&toast=1';
    }
    top?.location.replace(url);
  }
}
